<script>
import LazyImage from "@/components/atoms/lazy-image";
import Titre from "@/components/atoms/titre";
import Wallets from "@/components/molecules/wallets";

export default {
  name: "CarteFideliteViewer",
  components: {
    LazyImage,
    Titre,
    Wallets
  },
  props: {
    card: {
      type: Object,
      required: false,
      default: () => {}
    },
    isEligibleDefis: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div class="u-flex u-flex-column u-flex-align-center u-text-center u-pb-sm">
    <Titre
      tag="h2"
      size="md"
      variant="primary"
      class="u-mb-lg"
    >
      Ma carte {{ getCardType(card.attributes.sous_type) }}
    </Titre>
    <div class="c-carte-fidelite-viewer__card">
      <div class="c-carte-fidelite-viewer__img">
        <LazyImage
          :src="card.attributes.url_code_barre"
          height="80"
          alt=""
        />
        <p class="u-font-18 u-font-12@md u-font-700">
          {{ card.id }}
        </p>
      </div>
    </div>
    <Wallets
      v-if="card.attributes.url_wallet_apple || card.attributes.url_wallet_google"
      class="u-mt-lg"
      :url-wallet-google="card.attributes.url_wallet_google"
      :url-wallet-apple="card.attributes.url_wallet_apple"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/carte-fidelite-viewer.scss";
</style>
